import { render, staticRenderFns } from "./TipView.vue?vue&type=template&id=c8b406de&"
import script from "./TipView.vue?vue&type=script&lang=js&"
export * from "./TipView.vue?vue&type=script&lang=js&"
import style0 from "./TipView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports